import { accountSettings } from "@pjs/user-domain";
import { EMPTY, map } from "@pjs/observables";
import { createAsyncModelResult } from "@pjs/utilities";
import { feedbackTemplateIcon } from "@pjs/core-ui";
import { IViewConfig } from "../interfaces/IViewConfig";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { AssessmentPreferences } from "../../assessment-preferences/AssessmentPreferences.component";
import { accountSettingsActions } from "../../actions/AccountSettingsActions.const";
import { View } from "../enums/View";

export const assessmentView: IViewConfig = {
    id: View.Assessment,
    page: {
        get title() {
            return userUiI18n.getString("assessment.title");
        },
        get description() {
            return userUiI18n.getString("assessment.description");
        }
    },
    navigation: {
        icon: feedbackTemplateIcon,
        get label() {
            return userUiI18n.getString("settings_sidebar.buttons.assessment");
        }
    },
    component: () => {
        return accountSettings
            .getModel()
            .pipe(
                map((settings) => createAsyncModelResult(<AssessmentPreferences settings={settings.assessment} actions={accountSettingsActions.assessment} />))
            );
    },
    isEnabled: (_userDetails, settingsModel) => settingsModel.assessment.enabled,
    state: () => {
        return EMPTY;
    },
    clear: () => {
        accountSettings.clear();
    }
};
